import Typography, { TypographyProps } from '@mui/material/Typography'
import styled from 'styled-components'

import { textColor, textColorReverse, textDescr } from '../Colors'
import { textFont } from '../Fonts'
import { textBasicSize, textTitleSize } from '../Metrics/index'

export const Text = styled(Typography).attrs((props: TypographyProps) => ({
  sx: {
    color: textColor,
    fontSize: textBasicSize,
    fontFamily: textFont,
    ...props.sx
  },
  className: props.className
}))`
  background-color: transparent;
`

export const Title = styled(Typography).attrs((props: TypographyProps) => ({
  sx: {
    ...props.sx
  },
  className: props.className
}))`
  background-color: transparent;
  color: ${textColor};
  font-size: ${textTitleSize}px;
  font-weight: 700;
  text-transform: uppercase;
  font-family: ${textFont};
`

export const TextDescr = styled(Typography).attrs((props: TypographyProps) => ({
  sx: {
    ...props.sx
  },
  className: props.className
}))`
  background-color: transparent;
  color: ${textDescr};
  font-size: 13px;
  font-family: ${textFont};
`

export const TextButton = styled(Typography).attrs((props: TypographyProps) => ({
  sx: {
    ...props.sx
  },
  className: props.className
}))`
  background-color: transparent;
  color: ${textColorReverse};
  font-size: ${textBasicSize}px;
  font-family: ${textFont};
  margin: 0 auto;
`

export const CommonTextButton = styled(Typography).attrs((props: TypographyProps) => ({
  sx: {
    ...props.sx
  },
  className: props.className
}))`
  color: ${textColor};
  font-family: ${textFont};
  font-size: 23px;
`
